import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';
import LoadingButton from '@mui/lab/LoadingButton';
import { getStorage, ref, deleteObject } from "firebase/storage";
import { Alert } from '@mui/material';


export default function DeleteOutfitConfirmationModal({ outfit, setOpen, open, outfitId }) {
  const [user] = useAuthState(auth)
  const [loading, setLoading] = useState(null)
  const [deleteOutfitError, setDeleteOutfitError] = useState(null)
  const navigate = useNavigate()
  const { t } = useTranslation();


  const deleteInStorage = () => {
    const storage = getStorage();
    // Create a reference to the file to delete
    const desertRef = ref(storage, `outfits/${outfit.coverPhoto}`);
    // Delete the file
    deleteObject(desertRef).then(() => {
      console.log("borrado en storage")
    }).catch((error) => {
      console.log("fallo al borrar en storage", error)
    });

  }

  const handleDelete = async (outfit) => {
    setLoading(true)
    try {
      const outfitDocRef = doc(db, 'users', user.uid, 'outfits', outfitId)
      await deleteDoc(outfitDocRef)
      deleteInStorage(outfit)
      setLoading(null)
      setOpen(false);
      navigate("/")
      console.log("borrado en firebase")
    } catch (error) {
      setDeleteOutfitError(true)
      console.log("error borrando en firebase", error)
      setLoading(null)
    }
  }

  const handleClose = () => {
    setOpen(false);
    setDeleteOutfitError(null)
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('deleteOutfit.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('deleteOutfit.body')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
            aria-label="delete" loading={loading} onClick={() => handleDelete(outfit)}
          >
            <Button onClick={handleDelete} variant="contained" color="secondary">{t('deleteOutfit.yes')}</Button>
          </LoadingButton>
          <Button onClick={handleClose} variant="contained" autoFocus color="primary">
            {t('deleteOutfit.no')}
          </Button>
        </DialogActions>
        {deleteOutfitError != null &&
          <Alert severity="error" sx={{ margin: 1 }}>{t('deleteOutfit.errorMessage')}</Alert>
        }
      </Dialog>
    </div>
  );
}
